import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Grid, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { getSubVendorRegion } from "redux/actions/UserServiceCity";
import { getProfile, patchUpdateProfile } from "redux/actions/UserProfile";
import { getChooseYourService } from "redux/actions/UserChooseYourService";
import CommonForm from "components/commonForm/CommonForm";
import SuccessDialog from "components/successDialog/SuccessDialog";
import OtpDialog from "components/otpDialog/OtpDialog";
import CommonCropImage from "components/commonCropImage/CommonCropImage";
import Loader from "components/loader/Loader";
import SettingDialog from "./SettingDialog";
import SettingOurService from "./SettingOurService";
import { updatedSettingsForm2, updatedSettingsForm3 } from "./SettingData";
import camera from "assets/images/camera.svg";
import profile from "assets/images/SubVendorLogo.svg";

function Settings() {
  const id = localStorage.getItem("companyId");
  const dispatch = useDispatch();
  const userProfileData = useSelector(
    (state) => state?.userProfile?.userProfile?.data
  );
  const chooseYourServiceData = useSelector(
    (state) => state?.userChooseYourService?.userChooseYourService?.data
  );
  const serviceRegion = useSelector(
    (state) => state?.userSubVendorRegion?.userSubVendorRegion?.data
  );
  const loader = useSelector((state) => state?.userProfile?.loading);
  const [defaultValues, setDefaultValues] = useState({
    number: userProfileData?.mobile,
    email: userProfileData?.email,
  });
  const defaultValuesEmail = { email: userProfileData?.email };
  const defaultValuesMobile = { number: userProfileData?.mobile };

  const [editIconClicked, setEditIconClicked] = useState(false);
  const [editIconId, setEditIconId] = useState("");
  const [otpDialog, setOtpDialog] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const [value, setValue] = useState("1");
  const role = localStorage.getItem("role");
  const [image, setImage] = useState(
    userProfileData?.avatar?.url && userProfileData?.avatar != null
      ? userProfileData?.avatar?.url
      : null
  );
  const [imgError, setImgError] = useState("");
  const [fileTypeError, setFileTypeError] = useState("");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [openDialog, setOpenDialog] = useState(false);
  const [imageObj, setImageObj] = useState({});

  useEffect(() => {
    dispatch(getProfile());
    const data = {
      id: id,
      type: "Company",
    };
    dispatch(getChooseYourService(data));
    dispatch(getSubVendorRegion());
  }, []);

  useEffect(() => {
    if (userProfileData?.mobile) {
      const defaultNewValues = {
        ...defaultValues,
        number: userProfileData?.mobile || "",
        email: userProfileData?.email || "",
      };
      setDefaultValues(defaultNewValues);
    }
  }, [userProfileData?.mobile]);

  const handleEditIconClick = (id) => {
    setEditIconId(id);
    setEditIconClicked(!editIconClicked);
    dispatch(getProfile());
  };
  const onVerifyProfile = (data, code) => {
    setOtpDialog(false);
    setEditIconClicked(false);
    const val = {
      mobile: data?.number,
      email: data?.email,
      countryCode: "+91",
    };
    dispatch(patchUpdateProfile(val));
    setEditIconId("");
  };
  const handleClose = () => {
    setOtpDialog(false);
    setSuccessDialog(false);
  };

  const onOtpButton = () => {
    setOtpDialog(false);
    setSuccessDialog(true);
  };
  const onImageChange = (event) => {
    setFileTypeError("");
    if (event.target.files && event.target.files[0]) {
      const img = event.target.files[0];
      setImageObj(event.target.files[0]);
      const attributeType = ["image/jpeg", "image/png"];

      if (!attributeType.includes(img.type)) {
        const typeError = "File type should be in png/jpg/jpeg";
        setFileTypeError(typeError);
      } else if (event.target.files[0].size > 1024000) {
        const errorVal = "Image size should not be more than 1 MB";
        setImgError(errorVal);
      } else {
        setFileTypeError("");
        setSrc(URL.createObjectURL(img));
        setModalOpen(true);
      }
      event.target.value = '';
    }
  };

  const handleErrorImg = (event) => {
    const typeError = 'Please choose proper image'
    setFileTypeError(typeError)
    setModalOpen(false)
  }
  const [src, setSrc] = useState(null);
  
  // preview
  const [preview, setPreview] = useState(null);

  // modal state
  const [modalOpen, setModalOpen] = useState(false);

  const handleCropSave = (blob, img) => {
    setImage(URL.createObjectURL(blob));
    let formData = new FormData();
    const file = new File([blob], imageObj?.name, { lastModified: new Date() });
    formData.append("avtar", file);
    dispatch(patchUpdateProfile(formData));
  };

  return (
    <div>
      {loader ? (
        <Loader />
      ) : (
        <Grid container>
          <Grid item className="tableContainer" xs={12}>
            <Box className="contentBoxStyle">
              {role === 'subVendorCompany' ? 
              <TabContext value={value}>
                <Grid
                  container
                  className="tabBoxStyle"
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Grid item>
                    <TabList
                      onChange={handleChange}
                      aria-label="lab API tabs example"
                      className="marginTop25 minHeight32"
                    >
                      <Tab
                        label="Account Settings"
                        value="1"
                        className="tabStyle"
                      />
                      {role === "subVendorCompany" && (
                        <Tab
                          label="Your Services"
                          value="2"
                          className="tabStyle"
                        />
                      )}
                    </TabList>
                  </Grid>
                </Grid>
                <TabPanel
                  value="1"
                  className="vendotTable boxShadowSetting width100"
                >
                  <Grid
                    className="margin40"
                    container
                    direction="column"
                    justifyContent="flex-start"
                    md={6}
                  >
                    <Grid className="dpTextStyle">Profile Picture</Grid>
                    <Button
                      variant="contained"
                      component="label"
                      className="uploadBtn"
                    >
                      <CommonCropImage
                        modalOpen={modalOpen}
                        src={src}
                        setModalOpen={setModalOpen}
                        handleCropSave={handleCropSave}
                      />
                      <img
                        src={
                          image && image != null
                            ? image
                            : userProfileData?.avatar?.url &&
                              userProfileData?.avatar != null
                            ? userProfileData?.avatar?.url
                            : profile
                        }
                        alt="profile"
                        className="imgFormSize"
                      />
                      {src && <img
                        src={src}
                        alt="profile"
                        className="imgFormSize"
                        style={{display:'none'}}
                        onError={handleErrorImg}
                      />}
                      <div className="imgOuter">
                        <img src={camera} alt="camera" />
                      </div>
                      <input
                        type="file"
                        accept="image/*"
                        onChange={(e) => onImageChange(e)}
                        hidden
                      />
                    </Button>
                    {imgError && imgError !== null && (
                      <div className="errorMessage">{imgError}</div>
                    )}
                    {fileTypeError && fileTypeError !== null && (
                      <div className="errorMessage">{fileTypeError} </div>
                    )}
                    <CommonForm
                      formData={updatedSettingsForm2}
                      handleEditIconClick={handleEditIconClick}
                      editIconClicked={editIconClicked}
                      editIconId={editIconId}
                      onSubmittBtn={onVerifyProfile}
                      defaultValues={defaultValuesMobile}
                    />
                    <CommonForm
                      formData={updatedSettingsForm3}
                      handleEditIconClick={handleEditIconClick}
                      editIconClicked={editIconClicked}
                      editIconId={editIconId}
                      onSubmittBtn={onVerifyProfile}
                      defaultValues={defaultValuesEmail}
                    />
                  </Grid>
                </TabPanel>
                <TabPanel value="2" className="tabPanelStyle">
                  <SettingOurService
                    chooseYourServiceData={chooseYourServiceData}
                    serviceRegion={serviceRegion}
                  />
                </TabPanel>
              </TabContext> :
               <Grid
               className="margin40"
               container
               direction="column"
               justifyContent="flex-start"
               md={6}
             >
               <Grid className="dpTextStyle">Profile Picture</Grid>
               <Button
                 variant="contained"
                 component="label"
                 className="uploadBtn"
               >
                 <CommonCropImage
                   modalOpen={modalOpen}
                   src={src}
                   setModalOpen={setModalOpen}
                   handleCropSave={handleCropSave}
                 />
                 <img
                   src={
                     image && image != null
                       ? image
                       : userProfileData?.avatar?.url &&
                         userProfileData?.avatar != null
                       ? userProfileData?.avatar?.url
                       : profile
                   }
                   alt="profile"
                   className="imgFormSize"
                 />
                 {src && <img
                   src={src}
                   alt="profile"
                   className="imgFormSize"
                   style={{display:'none'}}
                   onError={handleErrorImg}
                 />}
                 <div className="imgOuter">
                   <img src={camera} alt="camera" />
                 </div>
                 <input
                   type="file"
                   accept="image/*"
                   onChange={(e) => onImageChange(e)}
                   hidden
                 />
               </Button>
               {imgError && imgError !== null && (
                 <div className="errorMessage">{imgError}</div>
               )}
               {fileTypeError && fileTypeError !== null && (
                 <div className="errorMessage">{fileTypeError} </div>
               )}
               <CommonForm
                 formData={updatedSettingsForm2}
                 handleEditIconClick={handleEditIconClick}
                 editIconClicked={editIconClicked}
                 editIconId={editIconId}
                 onSubmittBtn={onVerifyProfile}
                 defaultValues={defaultValuesMobile}
               />
               <CommonForm
                 formData={updatedSettingsForm3}
                 handleEditIconClick={handleEditIconClick}
                 editIconClicked={editIconClicked}
                 editIconId={editIconId}
                 onSubmittBtn={onVerifyProfile}
                 defaultValues={defaultValuesEmail}
               />
             </Grid>}
            </Box>
          </Grid>
        </Grid>
      )}
      {openDialog && <SettingDialog setOpenDialog={setOpenDialog} />}
      {otpDialog && (
        <OtpDialog
          open={otpDialog}
          handleClose={handleClose}
          onSubmittBtn={onOtpButton}
        />
      )}
      {successDialog && (
        <SuccessDialog
          open={successDialog}
          handleClose={handleClose}
          type={"Updated"}
          profileData={userProfileData}
        />
      )}
    </div>
  );
}

export default Settings;
